import { CONTENT_TYPES } from "../config";

var getLinkableContentTypesBySite = function getLinkableContentTypesBySite(site) {
  return Object.values(CONTENT_TYPES).filter(function (contentType) {
    return contentType.site === site && contentType.isLinkable;
  });
};

export default getLinkableContentTypesBySite;